import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './VerifyEmail.css'; // Reuse same styles

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const token = searchParams.get('token') || '';
  const emailParam = searchParams.get('email') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token || !emailParam) {
      setError('Ungültiger Reset-Link. Bitte fordere einen neuen an.');
      return;
    }

    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen haben');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailParam, token, password })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Fehler beim Zurücksetzen');
      } else {
        setSuccess('✅ Passwort erfolgreich geändert! Du wirst zum Login weitergeleitet...');
        setTimeout(() => navigate('/?login=true'), 2500);
      }
    } catch (err) {
      setError('Fehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        <div className="verify-header">
          <div className="verify-icon">🔑</div>
          <h1>Neues Passwort setzen</h1>
          <p>Vergib ein neues Passwort für deinen Account</p>
        </div>

        <div className="verify-content">
          {success && (
            <div className="message success">{success}</div>
          )}

          {error && (
            <div className="message error">⚠️ {error}</div>
          )}

          {!success && (
            <form onSubmit={handleSubmit} className="verify-form">
              <div className="form-group">
                <label htmlFor="password">Neues Passwort</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Mind. 8 Zeichen"
                  minLength="8"
                  required
                  disabled={loading}
                  className="email-input"
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirm">Passwort bestätigen</label>
                <input
                  id="confirm"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Passwort wiederholen"
                  minLength="8"
                  required
                  disabled={loading}
                  className="email-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading || password.length < 8}
                className="btn-verify"
              >
                {loading ? '⏳ Wird gespeichert...' : '✓ Passwort ändern'}
              </button>
            </form>
          )}
        </div>

        <div className="verify-footer">
          <p>
            <a href="/" className="link-back">← Zurück zur Startseite</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
